import {
  AUDIT_LOGS_FILTERABLE_FIELDS,
  type AuditLogsFilterableField,
} from '@kirin/api-client/contracts/audit-logs-table';

/**
 * URL keys for every audit-logs filterable field. Single source of truth —
 * column definitions reference this instead of hardcoding short keys.
 */
export const AUDIT_LOGS_FILTER_URL_KEYS = {
  [AUDIT_LOGS_FILTERABLE_FIELDS.TIMESTAMP]: 'ts',
  [AUDIT_LOGS_FILTERABLE_FIELDS.TABLE_NAME]: 'obj',
  [AUDIT_LOGS_FILTERABLE_FIELDS.OPERATION]: 'op',
  [AUDIT_LOGS_FILTERABLE_FIELDS.RECORD_ID]: 'oid',
  [AUDIT_LOGS_FILTERABLE_FIELDS.USER]: 'usr',
  [AUDIT_LOGS_FILTERABLE_FIELDS.CHANGES]: 'chg',
} as const satisfies Record<AuditLogsFilterableField, string>;

/** User cell/label text: name, else email, else "System". The raw id is never shown. */
export function formatAuditUserDisplay(
  userName: string | null,
  userEmail: string | null
): string {
  return userName || userEmail || 'System';
}
